import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ScrollToTop from '../components/scrollToTop/scrollToTop';
import Login from '../views/dashboard/login/login';
import Admin from '../views/dashboard/admin/admin';
import Error404 from '../components/error404/error404';
import GuiaDeEstilos from '../views/guia-de-estilos/main';
import HomeMain from '../views/home/main/main';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />,
    errorElement: <Error404 />,
  },
  {
    path: '/guia-de-estilos',
    element: <GuiaDeEstilos />,
  },
  {
    path: '/dashboard',
    children: [
      {
        path: '',
        element: <HomeMain />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'admin',
        element: <Admin />,
      },
    ],
  },
]);

const MyRoutes = () => <RouterProvider router={router}><ScrollToTop /></RouterProvider>;

export default MyRoutes;
